import { useState, useEffect } from 'react';
import { Button } from '@rsos/base-components';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { ButtonContainer } from './ActionableButton.styles';
import { findKey } from './utils';

/** NOTE: this button is meant to be generic, but 'generic' is still being defined,
 * it undergoes its road to maturity. Tracking might evolve with time and become a part of data itself,
 * same as `gainsight` is just a tool we currently use
 */
const ActionableButton = props => {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [link, setLink] = useState(null);
  const actionableButtonProperties =
    props?.schema?.componentProperties?.properties || {};

  useEffect(() => {
    if (props?.data) {
      const link = findKey(props.data, 'actionable_button');
      if (link && typeof link === 'string') {
        setButtonDisabled(false);
        setLink(link);
      }
    }
  }, [props]);

  const handleOpenLink = () => {
    const trackingName =
      actionableButtonProperties.gainsight?.trackingName || '';
    const trackingCategory =
      actionableButtonProperties.gainsight?.trackingCategory || '';
    gspx.trackEvent({
      name: 'map_actionable_button_click',
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.MAP,
      additionalKeys: {
        legacy_category: 'Data Map',
        legacy_name: trackingName,
        Category: trackingCategory,
        'Launched date': new Date(),
      },
    });
    if (link) {
      window.open(link, '_blank', 'noopener noreferrer');
    }
  };
  /** NOTE: similarly, the button itself might evolve with additional customizations on the type, width etc */
  return (
    <ButtonContainer>
      <Button
        btnType="primary"
        onClick={handleOpenLink}
        width="100%"
        disabled={buttonDisabled}
      >
        {actionableButtonProperties.label}
      </Button>
    </ButtonContainer>
  );
};

export default ActionableButton;
